/* ==========================================================================
   Fashiongirl sticky add to cart

   Shows the bar once the real add-to-cart button has scrolled out of view and
   hides it again when it returns, so the two never compete.

   Variant state lives in the bar's own selects. It also listens for Impulse's
   'variantChange' event, so picking a size in the main form keeps the bar in
   step, and picking one in the bar writes back to the main form's inputs.

   All strings come from data attributes filled by Liquid locale keys, so the bar
   is translated on every market with no JS-side copy.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-fg-satc]');
  if (!root) return;

  var addBtn = root.querySelector('[data-fg-satc-add]');
  var addText = root.querySelector('[data-fg-satc-add-text]');
  var priceEl = root.querySelector('[data-fg-satc-price]');
  var selects = Array.prototype.slice.call(root.querySelectorAll('[data-fg-satc-option]'));

  var variants = [];
  try {
    variants = JSON.parse(root.querySelector('[data-fg-satc-variants]').textContent);
  } catch (e) {
    return;
  }

  // Formatted against the market's presentment currency and the page language,
  // not shop.money_format, which is only correct on the primary market.
  var lang = document.documentElement.getAttribute('lang') || 'en';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  var formatter = null;
  if (currency) {
    try {
      formatter = new Intl.NumberFormat(lang, { style: 'currency', currency: currency });
    } catch (e) {
      formatter = null;
    }
  }

  function money(cents) {
    if (formatter) return formatter.format(cents / 100);
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  /* ---------- variant matching ---------- */

  function chosen() {
    return selects.map(function (s) { return s.value; });
  }

  function findVariant(values) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < values.length; j++) {
        if (String(v.options[j]) !== String(values[j])) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function paint(variant) {
    if (!variant) {
      addBtn.disabled = true;
      addBtn.removeAttribute('data-variant-id');
      addText.textContent = addBtn.getAttribute('data-text-unavailable') || '';
      return;
    }

    addBtn.setAttribute('data-variant-id', variant.id);
    addBtn.disabled = !variant.available;
    addText.textContent = variant.available
      ? addBtn.getAttribute('data-text-add')
      : addBtn.getAttribute('data-text-sold-out');

    if (priceEl) {
      var html = '<span class="fg-satc__now">' + money(variant.price) + '</span>';
      if (variant.compare_at_price > variant.price) {
        html += '<s class="fg-satc__was">' + money(variant.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
    }
  }

  function syncFromBar() {
    var variant = findVariant(chosen());
    paint(variant);

    // Write back to the main product form so the two never disagree
    if (!variant) return;
    var mainForm = document.querySelector('form[action*="/cart/add"]');
    if (!mainForm) return;

    selects.forEach(function (s) {
      var index = parseInt(s.getAttribute('data-index'), 10) + 1;
      var field = mainForm.querySelector('[name="options[' + s.getAttribute('aria-label') + ']"], .single-option-selector--' + index);
      if (field && field.value !== s.value) {
        field.value = s.value;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  selects.forEach(function (s) { s.addEventListener('change', syncFromBar); });

  // Impulse dispatches variantChange on the product container when the main
  // form changes; keep the bar's selects and price in step with it.
  document.addEventListener('variantChange', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    selects.forEach(function (s) {
      var value = variant.options[parseInt(s.getAttribute('data-index'), 10)];
      if (value != null && s.value !== value) s.value = value;
    });
    paint({
      id: variant.id,
      options: variant.options,
      available: variant.available,
      price: variant.price,
      compare_at_price: variant.compare_at_price || 0
    });
  });

  /* ---------- add to cart ---------- */

  addBtn.addEventListener('click', function () {
    var id = addBtn.getAttribute('data-variant-id');
    if (!id || addBtn.disabled || addBtn.hasAttribute('aria-busy')) return;

    addBtn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        // Brief inline confirmation, then reuse Impulse's own post-add
        // behaviour: rebuild the cart and open the drawer
        addBtn.classList.add('fg-satc__add--done');
        addText.textContent = addBtn.getAttribute('data-text-added') || addText.textContent;
        setTimeout(function () {
          addBtn.classList.remove('fg-satc__add--done');
          addText.textContent = addBtn.getAttribute('data-text-add');
        }, 1600);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .then(function () {
        addBtn.removeAttribute('aria-busy');
      });
  });

  /* ---------- show / hide ---------- */

  var sentinel = document.querySelector('[data-add-to-cart]');

  function reveal(on) {
    root.classList.toggle('fg-satc--in', on);
    root.setAttribute('aria-hidden', on ? 'false' : 'true');
    // Reserves the bar's real height at the foot of the document, so it never
    // permanently covers footer content or a cookie banner. Measured rather than
    // assumed, because the mobile bar is one row or two depending on whether the
    // product has options.
    if (on) {
      document.documentElement.style.setProperty('--fgSatcHeight', root.offsetHeight + 'px');
    }
    document.body.classList.toggle('fg-satc-active', on);
  }

  if (sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      reveal(!entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -20px 0px' }).observe(sentinel);
  } else if (sentinel) {
    var onScroll = function () {
      var box = sentinel.getBoundingClientRect();
      reveal(box.bottom < 0 || box.top > window.innerHeight);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  syncFromBar();
})();
